// degrees.jsx — a temperature as whole degrees in lining Cormorant,
// with the degree sign taken from the sans: Cormorant's own is nearly a
// full-size letter o. Shared by the home screen and the weather views.

import * as React from 'react';
import { FONT } from './theme.js';

export function Degrees({ T, value, size, color, weight = 500 }) {
  return (
    <span style={{
      fontFamily: FONT.serif, fontSize: size, fontWeight: weight, lineHeight: 1,
      color: color || T.ink, fontVariantNumeric: 'lining-nums tabular-nums',
    }}>
      {Math.round(value)}
      <span style={{ fontFamily: FONT.sans, fontWeight: 400, fontSize: Math.round(size * .4), verticalAlign: Math.round(size * .38), marginLeft: -1 }}>°</span>
    </span>
  );
}
